import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';
import type HotelRevpakSpiderDashboardRoute from 'lumen/routes/hotel/revpak/spider-dashboard';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelRevpakSpiderDashboardController extends Controller {
  declare model: ModelFrom<HotelRevpakSpiderDashboardRoute>;

  queryParams = [
    'asofDate',
    'data_replatforming',
    'debug',
    'ed_endDate',
    'ed_pickupFrom',
    'ed_startDate',
    'es_endDate',
    'es_pickupFromA',
    'es_pickupFromB',
    'es_startDate',
    'heatmapFilter',
    'heatmapMode',
    'heatmapYear',
    'outlook_30_endDate',
    'outlook_30_startDate',
    'outlook_60_endDate',
    'outlook_60_startDate',
    'outlook_90_endDate',
    'outlook_90_startDate',
    'outlook_pickupFromA',
    'outlook_pickupFromB',
    'pickupFrom',
    'segments_30_endDate',
    'segments_30_startDate',
    'segments_60_endDate',
    'segments_60_startDate',
    'segments_90_endDate',
    'segments_90_startDate',
    'segments_pickupFromA',
    'segments_pickupFromB',
    'showVariance',
    'str_endDate',
    'str_pickupFrom',
    'str_startDate',
    'tooltipHierarchy',
    'year',
  ];

  @service declare currency: Services['currency'];
  @service declare currencyConversion: Services['currency-conversion'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  declare dashboard: string;

  get iframeQPs(): Record<string, unknown> {
    const iframeQPs: Record<string, unknown> = {
      iframe: 1,
      origin: window.location.origin,
    };

    if (this.currency.selectedCurrency) {
      iframeQPs['currency'] = this.currency.selectedCurrency;
    }

    if (this.currencyConversion.selectedProfileId) {
      iframeQPs['currencyVariant'] = this.currencyConversion.selectedProfileId;
    }

    if (this.hotelAndMarketService.hotel) {
      iframeQPs['subscriptionId'] = this.hotelAndMarketService.hotel.id;
    }

    this.queryParams.forEach((queryParam) => {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const value = this[queryParam]!;

      if (value) {
        iframeQPs[queryParam] = value;
      }
    });

    return iframeQPs;
  }

  get urlForEmbeddedApp(): string {
    const { dashboard, model } = this;

    // @ts-expect-error: Incorrect type
    return `/dashboards/revpak/${model.spiderId}/${dashboard}`;
  }

  constructor() {
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);

    this.queryParams.forEach((queryParam) => {
      // @ts-expect-error: Incorrect type
      this[queryParam] = null;
    });
  }
}
